class CartGiftSelection extends Component {
    constructor(el) {
        super(el);

        this.cartRoot = document.querySelector('[data-step-cart]');
        this.submitButton = this.$el.querySelector('[data-submit]');
        this.closeButton = this.$el.querySelector('[data-close]');
        if (!this.cartRoot || !this.submitButton || !this.closeButton) {
            return; // Ne vždy je na výběr z dárků, pokud není výběr k dispozici, tak dál ani nepokračujeme.
        }

        this.isPopupOpened = VueReactivity.ref(false);

        this.openGiftSelectionButtonsBySelectionId = new Map();
        const openGiftSelectionButtons = this.cartRoot.querySelectorAll(`[data-selection-id]`);
        openGiftSelectionButtons && openGiftSelectionButtons.forEach(element => {
            this.openGiftSelectionButtonsBySelectionId.set(element.dataset.selectionId, element);
        });

        this.selectionSectionsBySelectionId = VueReactivity.reactive(new Map());
        this.sections = this.$el.querySelectorAll('[data-selection-for-id]');
        this.sections.forEach(section => {
            const selectionId = section.dataset.selectionForId;
            const defaultSelectedValue = section.dataset.defaultSelectedValue;
            this.selectionSectionsBySelectionId.set(selectionId, {
                isOpenedSection: false,
                defaultSelectedValue: defaultSelectedValue,
                element: section,
            });
        });

        this.addEventListeners();

        VueReactivity.watch(this.isPopupOpened, () => {
            const isOpen = this.isPopupOpened.value;
            this.$el.classList.toggle('is-active', isOpen);
            document.body.style.overflow = isOpen ? 'hidden' : '';
        }, {immediate: true});

        VueReactivity.watch(this.selectionSectionsBySelectionId, () => {
            this.selectionSectionsBySelectionId.forEach((section) => {
                section.element.classList.toggle('is-active', section.isOpenedSection);
            });
        }, {immediate: true});
    }

    showSectionById(id) {
        const section = this.selectionSectionsBySelectionId.get(id);
        if (section) {
            section.isOpenedSection = true;
        }

        if (!this.isPopupOpened.value) { // Pokud ještě není popup otevřen, tak ho otevřeme.
            this.isPopupOpened.value = true;
        }
    }

    addEventListeners() {
        this.submitButton.addEventListener('click', e => {
            e.preventDefault();
            EventBus.getInstance().dispatchEvent('orderUpdateStepCart');
        });

        this.openGiftSelectionButtonsBySelectionId.forEach((button, selectionId) => {
            button.addEventListener("click", () => {
                this.showSectionById(selectionId);
            });
        });

        // Handle close
        this.closeButton.addEventListener("click", () => {
            this.isPopupOpened.value = false;
            setTimeout(() => {
                this.selectionSectionsBySelectionId.forEach(section => {
                    section.isOpenedSection = false;

                    section.element.querySelectorAll('input[type="radio"]').forEach(input => {
                        input.checked = input.value === section.defaultSelectedValue; // Pokud došlo k nějaké změně, tak rezetujeme do původního stavu.
                    });
                });
            }, 400);
        });

        // Handle hover effect on selection items
        this.cartRoot.querySelectorAll('.CartFormGiftSelectionSection-input').forEach(input => {
            input.addEventListener('mouseenter', () => {
                input.closest('.CartFormGiftSelectionSection-option')?.classList.add('is-hovered');
            });

            input.addEventListener('mouseleave', () => {
                input.closest('.CartFormGiftSelectionSection-option')?.classList.remove('is-hovered');
            });
        });
    }
}
